module.exports = __webpack_public_path__ + "media/images/selectionBet__flagBg-8cd05f7d16578530d37beffa720b9774.jpg";